import { SynchronizeAccountsApi } from "@/features/accounts/creca/services/synchronize-accounts-api";
import { SynchronizeAccountsRequestModel } from "@/features/accounts/creca/services/synchronize-accounts-model";

/// クレカアカウント同期処理
export class SynchronizeAccountsService {
  private synchronizeAccountsApi = new SynchronizeAccountsApi();

  /**
   * クレカアカウント同期API実行
   */
  public async synchronizeAccounts(param: SynchronizeAccountsRequestModel) {
    return await this.synchronizeAccountsApi.synchronizeAccounts(param);
  }
}
